<template>
	<v-dialog v-model="showDialog" persistent max-width="500">
		<v-card>
			<v-card-title class="text-h5 sector-head py-5">
				Seleccionar Empresa
			</v-card-title>
			<v-card-text class="pt-5">
				<v-select
					v-model="selectedCompany"
					:items="companies"
					item-text="name"
					item-value="id"
					label="Empresa"
					outlined
					:return-object="true"
				></v-select>
			</v-card-text>
			<v-card-actions class="py-5 d-flex justify-center">
				<v-btn
					outlined
					color="primary"
					class="rounded-pill px-8"
					@click="cancel"
				>
					Cancelar
				</v-btn>
				<v-btn
					color="primary"
					class="rounded-pill px-8 ml-5"
					@click="confirm"
					:disabled="!selectedCompany"
				>
					Guardar
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
export default {
	name: 'SelectCompanySimplePopup',

	props: {
		show: {
			type: Boolean,
			required: true
		},
		companies: {
			type: Array,
			default: () => []
		}
	},

	data() {
		return {
			selectedCompany: null,
			showDialog: false
		}
	},

	watch: {
		show(val) {
			this.showDialog = val;
			if (val) {
				this.selectedCompany = null;
			}
		}
	},

	methods: {
		cancel() {
			this.$emit('close');
		},
		confirm() {
			if (this.selectedCompany) {
				this.$emit('save', this.selectedCompany);
			}
		}
	}
}
</script>

<style scoped>
.sector-head {
	background-color: #f9f6fe;
	color: var(--v-primaryDark-base);
}
</style>
